import { render, staticRenderFns } from "./DotTable.vue?vue&type=template&id=e8e72324&scoped=true&"
import script from "./DotTable.vue?vue&type=script&lang=js&"
export * from "./DotTable.vue?vue&type=script&lang=js&"
import style0 from "./DotTable.vue?vue&type=style&index=0&id=e8e72324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e72324",
  null
  
)

export default component.exports